import { render, staticRenderFns } from "./EditIconV2.vue?vue&type=template&id=7f5a6358&scoped=true"
import script from "./EditIconV2.vue?vue&type=script&lang=js"
export * from "./EditIconV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5a6358",
  null
  
)

export default component.exports